<template>
    <section class="top-courses-section">


        <div class="custom-container">
            <div class="row align-items-center">
                 <div class="col-md-12 col-lg-2">
                    <VueSlickCarousel v-bind="settingBlog"> 
                        <div v-for="(item, index) in lstblog" v-bind:key="index" class="kt-portlet kt-portlet--height-fluid kt-widget19">
                            <div class="kt-portlet__body kt-portlet__body--fit kt-portlet__body--unfill">
                                <div class="kt-widget19__pic kt-portlet-fit--top kt-portlet-fit--sides" style="min-height: 300px; ">
                                    <h3 class="kt-widget19__title kt-font-light">
                                        Judul Blog {{index}}
                                    </h3>
                                    <div class="kt-widget19__shadow"></div>
                                    <div class="kt-widget19__labels">
                                        <a href="#" class="btn btn-label-light-o2 btn-bold ">Recent</a>
                                    </div>
                                </div>
                            </div>
                            <div class="kt-portlet__body">
                                <div class="kt-widget19__wrapper">
                                    <div class="kt-widget19__content">
                                        <div class="kt-widget19__userpic">
                                            <img src="@/assets/img/user2.jpg" alt="">
                                        </div>
                                        <div class="kt-widget19__info">
                                            <a href="#" class="kt-widget19__username">
                                                Anna Krox
                                            </a>
                                            <span class="kt-widget19__time">
                                                UX/UI Designer, Google
                                            </span>
                                        </div>
                                        <div class="kt-widget19__stats">
                                            <span class="kt-widget19__number kt-font-brand">
                                                18
                                            </span>
                                            <a href="#" class="kt-widget19__comment">
                                                Comments
                                            </a>
                                        </div>
                                    </div>
                                    <div class="kt-widget19__text">
                                        Lorem Ipsum is simply dummy text of the printing and typesetting scrambled a type specimen book text of the dummy text of the printing printing and typesetting industry scrambled dummy text of the printing.
                                    </div>
                                </div>
                                <div class="kt-widget19__action">
                                    <a href="#" class="btn btn-sm btn-label-brand btn-bold">Read More...</a>
                                </div>
                            </div>
                        </div>
                    </VueSlickCarousel>
                 </div>
            </div>
        </div>

        
    </section>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import topcourses from '../../../assets/json/topcourses'
const courseimages = require.context('@/assets/img/courses', false, /\.png$|\.jpg$/)
const userimages = require.context('@/assets/img', false, /\.png$|\.jpg$/)

import axios from 'axios';
import {mapGetters} from 'vuex'
// import Slick from 'vue-slick';

export default {
    // components: { Slick },
    components: { VueSlickCarousel },
    
    data() {
        return {
            lstpaket: [],
            topcourses: topcourses,
             slickOptions: {},
             idcat: '',
            lstblog: [1, 2, 3, 4, 5],
            settingBlog: {
                "dots": false,
                "infinite": true,
                "centerMode": true,
                "centerPadding": "20px",
                "slidesToShow": 1,
                "slidesToScroll": 1,
                "variableWidth": true
            },
            settingCategory: {
                
                "infinite": true,
                "slidesToShow": 4,
                "speed": 500,
                "rows": 4,
                "slidesPerRow": 1
                
                // arrows: false,
                // "dots": false,
                // "infinite": false,
                // "speed": 500,
                // "slidesToShow": 6,
                // "slidesToScroll": 6,
                // "initialSlide": 0,
                // "responsive": [
                //     {
                //     "breakpoint": 1024,
                //     "settings": {
                //         "slidesToShow": 3,
                //         "slidesToScroll": 3,
                //         "infinite": true,
                //         "dots": true
                //     }
                //     },
                //     {
                //     "breakpoint": 600,
                //     "settings": {
                //         "slidesToShow": 3,
                //         "slidesToScroll": 3,
                //         "initialSlide": 2
                //     }
                //     },
                //     {
                //     "breakpoint": 480,
                //     "settings": {
                //         "slidesToShow": 4,
                //         // "rows": 2,
                //         // "slidesPerRow": 1
                //         "slidesToScroll": 1
                //     }
                //     }
                // ]
                }
        
        }
    },    
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        })
    },
    created:function(){
        this.idcat = this.$route.query.idcat
        this.getAll();
        this.slickOptions= {
            dots: false,
            autoplay:false,
            infinite: true,
            variableWidth: false,
            slidesToShow: 4,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    },
     methods: {
        getAll: function () {
            axios.get('paketgeneral/'+this.idcat)
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tbl");
                    this.lstpaket = res.data.data;
                    // this.slickOptions = {
                    //         dots: false,
                    //         autoplay:false,
                    //         infinite: true,
                    //         variableWidth: false,
                    //         slidesToShow: 4,
                    //         responsive: [
                    //             {
                    //                 breakpoint: 1024,
                    //                 settings: {
                    //                     slidesToShow: 3,
                    //                     slidesToScroll: 3
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 767,
                    //                 settings: {
                    //                     slidesToShow: 2,
                    //                     slidesToScroll: 2
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 480,
                    //                 settings: {
                    //                     slidesToShow: 1,
                    //                     slidesToScroll: 1
                    //                 }
                    //             }
                    //         ]
                    //     }
                    // this.$refs.slick({
                    //     // this.slickOptions = {
                    //         dots: false,
                    //         autoplay:false,
                    //         infinite: true,
                    //         variableWidth: false,
                    //         slidesToShow: 4,
                    //         responsive: [
                    //             {
                    //                 breakpoint: 1024,
                    //                 settings: {
                    //                     slidesToShow: 3,
                    //                     slidesToScroll: 3
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 767,
                    //                 settings: {
                    //                     slidesToShow: 2,
                    //                     slidesToScroll: 2
                    //                 }
                    //             },
                    //             {
                    //                 breakpoint: 480,
                    //                 settings: {
                    //                     slidesToShow: 1,
                    //                     slidesToScroll: 1
                    //                 }
                    //             }
                    //         ]
                    //     // }
                    // });
                    
					// console.log(res.data.data);
                    // this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
        
        getDetail: function (ref) {
            // if(localStorage.getItem('idUser'))
            if(this.isLoggedIn){
                
                localStorage.setItem("idPaket",  ref.id_paket); 
                this.$router.push({name:'siswa-paket-belajar-detail'});//, params: {id: ref.id_paket}});
            
            }
            else
                this.$router.push({name:'home-detail-paket', params: {id: ref.id_paket}});

        },

	  loadImg(imgPath, type) {
          if(type === 1) {
              return courseimages('./' + imgPath)
          } else {
              return userimages('./' + imgPath)
          }
        
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Category/TopCourses/index.vue